export default {
  // Modal 标题
  查看物料异常: "查看物料異常",
  编辑物料异常: "編輯物料異常",
  登记物料异常标题: "登記物料異常",

  // 表格列标题
  处理状态: "處理狀態",
  物料编号: "物料編號",
  物料名称: "物料名稱",
  物料类别: "物料類別",
  二级物料类别: "二級物料類別",
  物料进仓批号: "物料進倉批號",
  供应商编号: "供應商編號",
  "供应商名称（中文）": "供應商名稱（中文）",
  "供应商名称（英文）": "供應商名稱（英文）",
  相关生产商名称: "相關生產商名稱",
  生产批号: "生產批號",
  PO单号: "PO單號",
  发现日期: "發現日期",
  发起人: "發起人",
  发起部门: "發起部門",
  操作: "操作",

  // 状态值
  草稿: "草稿",
  待SCM提交意见: "待SCM提交意見",
  待QA提交意见: "待QA提交意見",
  待通知供应商: "待通知供應商",
  待供应商提供解决方案: "待供應商提供解決方案",
  解决方案审批中: "解決方案審批中",
  已驳回解决方案: "已駁回解決方案",
  已完结: "已完結",
  未知: "未知",

  // 操作按钮
  编辑: "編輯",
  删除: "刪除",
  查看: "查看",

  // 搜索字段
  物料: "物料",
  供应商: "供應商",
  请输入物料进仓批号: "請輸入物料進倉批號",
  请输入物料名称: "請輸入物料名稱",
  请输入供应商名称: "請輸入供應商名稱",
  请选择物料类别: "請選擇物料類別",
  请选择处理状态: "請選擇處理狀態",
  请选择发起人: "請選擇發起人",

  // 物料类别级联选项
  生产物料: "生產物料",
  非生产物料: "非生產物料",
  API: "API",
  "輔料（Excipient）": "輔料（Excipient）",
  包材: "包材",
  RLD: "RLD",
  工程建设: "工程建設",
  "设备/设施/仪器": "設備/設施/儀器",
  MRO: "MRO",
  行政物资: "行政物資",
  IT物资: "IT物資",
  外包服务: "外包服務",

  // 列表标题和按钮
  物料异常登记列表: "物料異常登記列表",
  登记物料异常: "登記物料異常",

  // 分页
  共条数据: "共 {{totalCount}} 筆數據",

  // 表单标签
  员工姓名: "員工姓名",
  员工工号: "員工工號",
  创建日期: "建立日期",
  部门: "部門",
  岗位: "崗位",
  邮箱: "郵箱",
  异常物料信息: "異常物料信息",
  工厂: "工廠",
  请输入搜索物料编号: "請輸入搜尋物料編號",
  请输入物料编号搜索: "請輸入物料編號搜尋",
  请选择物料类别表单: "請選擇物料類別表單",
  请选择二级物料类别: "請選擇二級物料類別",
  企业类型: "企業類型",
  请选择相关生产商: "請選擇相關生產商",
  发现异常日期: "發現異常日期",
  请选择发现日期: "請選擇發現日期",
  涉及异常数量: "涉及異常數量",
  是否回仓冻结: "是否回倉凍結",
  请选择通用: "請選擇通用",
  回仓或冻结数量: "回倉或凍結數量",
  请输入回仓或冻结数量: "請輸入回倉或凍結數量",
  额外工时涉及赔付: "額外工時涉及賠付",
  问题描述: "問題描述",
  请输入问题描述: "請輸入問題描述",
  供应商标签照片: "供應商標籤照片",
  请上传供应商标签照片: "請上傳供應商標籤照片",
  相关照片或证明文件: "相關照片或證明文件",
  请上传相关照片或证明文件: "請上傳相關照片或證明文件",
  决定退款换货: "決定退款換貨",
  请选择决定退款换货: "請選擇決定退款換貨",
  质量诉求: "質量訴求",
  是否需要调查反馈: "是否需要調查反饋",
  期望解决日期: "期望解決日期",
  请选择期望解决日期: "請選擇期望解決日期",
  诉求说明: "訴求說明",
  供应商解决方案: "供應商解決方案",
  备注说明: "備註說明",
  请输入备注说明表单: "請輸入備註說明表單",
  审批信息: "審批信息",
  审批意见: "審批意見",
  意见说明: "意見說明",
  同意: "同意",
  驳回: "駁回",
  请输入意见说明: "請輸入意見說明",

  // 表单占位符
  请输入员工姓名: "請輸入員工姓名",
  请输入员工工号: "請輸入員工工號",
  请输入创建日期: "請輸入建立日期",
  请输入部门: "請輸入部門",
  请输入岗位: "請輸入崗位",
  请输入邮箱: "請輸入郵箱",
  请输入供应商名称中文: "請輸入供應商名稱中文",
  请输入供应商名称英文: "請輸入供應商名稱英文",
  由物料编号自动填写: "由物料編號自動填寫",
  由物料进仓批号自动带出: "由物料進倉批號自動帶出",

  // 选项值
  代理商: "代理商",
  生产商: "生產商",
  是: "是",
  否: "否",
  退款: "退款",
  换货: "換貨",

  // 其他
  单号: "單號",
  点击上传: "點擊上傳",

  // 消息提示
  请先选择公司和物料编号: "請先選擇公司和物料編號",
  获取批号信息失败: "獲取批號信息失敗",
  获取物料异常登记列表失败: "獲取物料異常登記列表失敗",
  已登记: "已登記",
  提交失败: "提交失敗",
  已暂存: "已暫存",
  暂存失败: "暫存失敗",
  已通知供应商: "已通知供應商",
  通知供应商失败: "通知供應商失敗",
};
